import theme from '@/constants/theme';

const CARD_WIDTH = 120;
const CARD_HEIGHT = 122;

const styles: Record<string, React.CSSProperties> = {
  cardContainer: {
    minWidth: CARD_WIDTH,
    width: 'auto',
    height: CARD_HEIGHT,
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: theme.colors.secondary,
    position: 'relative',
  },
  img: {
    flex: 1,
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
  },
  numberText: {
    position: 'absolute',
    top: -12,
    left: 12,
    fontSize: 64,
    color: '#fff',
    opacity: 0.9,
    fontWeight: 'bold',
    textShadow: '0 1px 3px rgba(0,0,0,0.8)',
  },
  progressText: {
    position: 'absolute',
    top: 8,
    right: 8,
    fontSize: 16,
    color: '#fff',
    fontWeight: '600',
    textShadow: '0 1px 3px rgba(0,0,0,0.8)',
  },
  titleText: {
    position: 'absolute',
    bottom: 10,
    left: 16,
    color: theme.colors.text.default,
    textShadow: '0 1px 3px rgba(0,0,0,0.8)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    fontWeight: "normal"
  },
  overlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '60%',
    background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.6) 50%, rgba(0,0,0,0) 100%)',
  },
};

export default styles;
